module.exports = {"140721100":"箕城镇","140721101":"云簇镇","140721102":"郝北镇","140721103":"社城镇","140721200":"河峪乡","140721201":"北寨乡","140721202":"西马乡","140721203":"岚峪乡","140721204":"讲堂乡","140721400":"城区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140721.json
// module id = 282
// module chunks = 0